import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SpendingReportService {

  private url = environment.api;

  constructor(
    private http: HttpClient,
  ) { }

  getSpendingReport(account: number | null, startDate: number, endDate: number, type: string) {
    const params: any = {
      startDate: startDate,
      endDate: endDate
    };

    if (account != null) {
      params.account = account;
    }

    return this.http.get(this.url + "api/erp/expense/report/report1/" + type, {
      params: params
    });
  }

  getSpendingReport2(account: number, startDate:number, endDate:number, type: string) {
    const params: any = {
      startDate: startDate,
      endDate: endDate
    };

    if (account != null) {
      params.account = account;
    }

    return this.http.get(this.url + "api/erp/expense/report/report2/" + type, {
      params: params
    });
  }

  getSpendingReport3(account: number, startDate:number, endDate:number, type: string) {
    const params: any = {
      startDate: startDate,
      endDate: endDate
    };

    if (account != null) {
      params.account = account;
    }

    return this.http.get(this.url + "api/erp/expense/report/report3/" + type, {
      params: params
    });
  }
}
